import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import classNames from 'classnames';

const GlobalMenuGroupPres = ({ text, children, isOpen, toggleGroup }) => {
  const menuItemClass = classNames('menu-item', {
    open: isOpen,
  });

  //// console.log('@menuItemsClass', menuItemClass);

  return (
    <Fragment>
      <ListItem button className={menuItemClass} onClick={toggleGroup}>
        <ListItemText primary={text} className="menu-text" />
        {isOpen ? <ExpandLess className="icon" /> : <ExpandMore className="icon" />}
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding className="menu-group-children">
          {children}
        </List>
      </Collapse>
    </Fragment>
  );
};

GlobalMenuGroupPres.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  toggleGroup: PropTypes.func.isRequired,
};

export default GlobalMenuGroupPres;



// WEBPACK FOOTER //
// ./src/ui/library/GlobalMenu/GlobalMenuGroupPres.js